import { formatDistanceToNow, format } from 'date-fns';

export function timeAgo(dateStr) {
  if (!dateStr) return '—';
  try {
    return formatDistanceToNow(new Date(dateStr), { addSuffix: true });
  } catch {
    return '—';
  }
}

export function formatDate(dateStr) {
  if (!dateStr) return '—';
  try {
    return format(new Date(dateStr), 'dd MMM yyyy, hh:mm a');
  } catch {
    return '—';
  }
}

export function formatDuration(seconds) {
  if (!seconds) return '0s';
  if (seconds < 60) return `${seconds}s`;
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return s > 0 ? `${m}m ${s}s` : `${m}m`;
}

export function callTypeBadge(type, call) {
  // A call with zero duration and no recording never actually connected
  // (e.g. owner hung up before the other party answered, or before any
  // audio was captured). This is distinct from "unknown" — unknown means
  // "classification hasn't run yet or failed", not "nothing happened".
  if (call && (call.duration === 0 || call.duration === null) && !call.recording_url) {
    return { label: 'Not Connected', class: 'badge-gray' };
  }

  const map = {
    sales_lead: { label: 'Sales Lead', class: 'badge-green' },
    service_request: { label: 'Service', class: 'badge-blue' },
    complaint: { label: 'Complaint', class: 'badge-red' },
    enquiry: { label: 'Enquiry', class: 'badge-orange' },
    follow_up: { label: 'Follow Up', class: 'badge-cyan' },
    spam: { label: 'Spam', class: 'badge-gray' },
    no_answer: { label: 'No Answer', class: 'badge-gray' },
    busy: { label: 'Busy', class: 'badge-gray' },
    voicemail_no_message: { label: 'Voicemail (no msg)', class: 'badge-gray' },
    no_content: { label: 'No Content', class: 'badge-gray' },
    unknown: { label: 'Unknown', class: 'badge-gray' },
  };
  return map[type] || { label: type || 'Unknown', class: 'badge-gray' };
}

export function urgencyBadge(urgency) {
  const map = {
    high: { label: 'High', class: 'badge-red' },
    medium: { label: 'Medium', class: 'badge-orange' },
    low: { label: 'Low', class: 'badge-green' },
  };
  return map[urgency] || { label: urgency || '—', class: 'badge-gray' };
}

export function sentimentEmoji(sentiment) {
  const map = {
    positive: '😊',
    neutral: '😐',
    negative: '😟',
  };
  return map[sentiment] || '😐';
}

export function pipelineLabel(stage) {
  const map = {
    new_lead: 'New Lead',
    contacted: 'Contacted',
    proposal_sent: 'Proposal Sent',
    won: 'Won',
    lost: 'Lost',
  };
  return map[stage] || stage;
}

export function pipelineBadge(stage) {
  const map = {
    new_lead: 'badge-blue',
    contacted: 'badge-cyan',
    proposal_sent: 'badge-orange',
    won: 'badge-green',
    lost: 'badge-gray',
  };
  return map[stage] || 'badge-gray';
}
